import React from "react";
import { Draggable } from "react-beautiful-dnd";

const Task = (props) => {
  let status_color = props?.task?.task_status?.name
    ? props?.task?.task_status?.name.toLowerCase()
    : props?.task?.task_status?.term_slug
    ? props?.task?.task_status?.term_slug
    : props?.task?.factor_description_type === "Minus"
    ? "red"
    : props?.task?.factor_description_type === "Plus"
    ? "green"
    : "";

  return (
    <Draggable draggableId={`${props.task.id}`} index={props.index}>
      {(provided, snapshot) => (
        <div style={{ position: "relative" }}>
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            className={` custom-classrounded task-wrap border-2 p-3 mb-3 rounded-3 dragable single-task-item ${
              snapshot.isDragging ? "bg-primary border-primary" : "bg-white"
            }`}
            onClick={() => {
              props.setSelectedColumn(props.columnId);
              //props.setSelectedTask(props.task);
              props.openEditModel();
            }}
          >
            {props.task.title?.replaceAll("&amp;", "&")}
            {props.showStatus && (
              <div
                className={`position-absolute rounded-circle right-0 bg-sy-${status_color}`}
                style={{
                  width: "10px",
                  height: "10px",
                  marginRight: "10px",
                  bottom: "10px",
                  top: "5px",
                  right: 0,
                  backgroundColor: status_color,
                  borderRadius: "50%",
                }}
              ></div>
            )}
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default Task;
